import React from 'react'

const Marqueur = ({ taille, ...props }) => (
  <svg
    width={taille}
    height={taille}
    {...props}
    viewBox='0 0 17 14'
    style={{ enableBackground: 'new 0 0 17 14' }}
  >
    <g transform='translate(-1615 2711)'>
      <rect x='1615' y='-2699.5' fill='#95989A' width='17' height='1' />
      <rect x='1615' y='-2704.5' fill='#95989A' width='17' height='1' />
      <rect x='1615' y='-2709.5' fill='#95989A' width='17' height='1' />
      <g transform='translate(28 100)'>
        <circle fill='#FFFFFF' cx='1600' cy='-2799' r='2' />
        <path
          fill='#95989A'
          d='M1600-2797c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S1601.1-2797,1600-2797z M1600-2800c-0.6,0-1,0.4-1,1
        s0.4,1,1,1s1-0.4,1-1S1600.6-2800,1600-2800z'
        />
      </g>
      <g transform='translate(20 95)'>
        <circle fill='#FFFFFF' cx='1600' cy='-2799' r='2' />
        <path
          fill='#95989A'
          d='M1600-2797c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C1602-2797.9,1601.1-2797,1600-2797z M1600-2800
        c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S1600.6-2800,1600-2800z'
        />
      </g>
      <g transform='translate(26 90)'>
        <circle fill='#FFFFFF' cx='1600' cy='-2799' r='2' />
        <path
          fill='#95989A'
          d='M1600-2797c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S1601.1-2797,1600-2797z M1600-2800c-0.6,0-1,0.4-1,1
        s0.4,1,1,1s1-0.4,1-1S1600.6-2800,1600-2800z'
        />
      </g>
    </g>
  </svg>
)

export default Marqueur
